__turbopack_context__.v({
  "buyLink": "_0ByagG_buyLink",
  "cardContainer": "_0ByagG_cardContainer",
  "description": "_0ByagG_description",
  "filler": "_0ByagG_filler",
  "imgContainer": "_0ByagG_imgContainer",
  "textContainer": "_0ByagG_textContainer",
  "title": "_0ByagG_title",
});
